import userManagement from '../providers/userManagement';
import parseGroupMetadata from './parseGroupMetadata';

async function getAllNestedGroups(parentGroupId) {
  return (await userManagement.get(
    `/extension/groups/${parentGroupId}/nested`
  )).data.map((group) => ({
    ...group,
    metadata: parseGroupMetadata(group),
  }));
}

async function getMyGroups(user) {
  let groups = (await userManagement.get(
    `/extension/users/${user.id}/groups`
  )).data.map((group) => ({
    ...group,
    metadata: parseGroupMetadata(group),
  }));
  // If we are displaying subgroups, filter out groups without parent
  groups = groups.filter((group) => group.metadata.parent);
  // Filter for groups that belong to the active org
  const app_metadata = user['https://vrpatients.com/app_metadata'];
  if (app_metadata.activeOrg) {
    groups = groups.filter((group) => group.metadata.parent === app_metadata.activeOrg);
  }
  await Promise.all(
    groups.map(async (group) => {
    const response = await userManagement.get(
      `/extension/groups/${group._id}/members`,
      {
      page: 999,
      }
    );
    group.members = new Array(response.data.total);
    })
  );
  return groups;
}

export default async function fetchGroupData(user, parentGroupId) {
  const userRole = user.role;
  const isAdmin = userRole === 'ADMIN' || userRole === 'SUPER_ADMIN';
  const parentGroup = user.groupsData && user.groupsData.find(g => g._id === parentGroupId);
  const isKeyOwner = parentGroup && parentGroup.metadata.ownerId === user.user_id;
  if (isAdmin || isKeyOwner) {
    return getAllNestedGroups(parentGroupId);
  }
  return getMyGroups(user);
}
